import { Component, OnInit } from '@angular/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.css']
})
export class FaqComponent implements OnInit {

  constructor() { }

  ngOnInit() {
    (<any>window).gtag('config', environment.gaId, { 'page_path': `/faq` });
  }
  // https://embed.plnkr.co/afhLA8wHw9LRnzwwTT3M/
}



// WEBPACK FOOTER //
// ./public/app/modules/faq/faq.component.ts